module.exports = JSON.parse("{\"1\":[],\"2\":[],\"3\":[]}")